/**
 * Format a numeric value with the appropriate unit label.
 * Unit names match Grafana's unit system.
 */
export function formatValue(value: number | null | undefined, unit: string): string {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return 'N/A';
  }

  switch (unit) {
    case 'reqps':
      return `${trimDecimals(value)} req/s`;

    case 's':
      if (Math.abs(value) < 0.001) return `${trimDecimals(value * 1_000_000)} µs`;
      if (Math.abs(value) < 1) return `${trimDecimals(value * 1000)} ms`;
      return `${trimDecimals(value)} s`;

    case 'ms':
      if (Math.abs(value) < 1) return `${trimDecimals(value * 1000)} µs`;
      if (Math.abs(value) >= 1000) return `${trimDecimals(value / 1000)} s`;
      return `${trimDecimals(value)} ms`;

    case 'percentunit':
      return `${trimDecimals(value * 100)}%`;

    case 'bytes':
      return formatBytes(value);

    case 'ops':
      return `${trimDecimals(value)} ops/s`;

    case 'short':
    default:
      return trimDecimals(value);
  }
}

function trimDecimals(v: number): string {
  if (Number.isInteger(v)) return v.toString();
  if (Math.abs(v) >= 100) return v.toFixed(0);
  if (Math.abs(v) >= 10) return v.toFixed(1);
  return v.toFixed(2);
}

function formatBytes(bytes: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;
  let v = Math.abs(bytes);
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${bytes < 0 ? '-' : ''}${trimDecimals(v)} ${units[i]}`;
}
